import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EventCheckoutRoutePaths } from '../eventregistration.component';

@Component({
  selector: 'app-check-before-redirect',
  templateUrl: './check-before-redirect.component.html',
  styleUrls: ['./check-before-redirect.component.scss']
})
export class CheckBeforeRedirectComponent implements OnInit {

  private readableEventId: string;
  private responseCode: string;
  toConfirmation: boolean;

  constructor(
    private route: ActivatedRoute,
    public router: Router,
  ) { }

  ngOnInit() {
    this.readableEventId = this.route.snapshot.queryParams['readableEventId'];
    this.responseCode = this.route.snapshot.queryParams['responseCode'];
    //Si le status code est bon alors l'utilisateur est renvoyé sur la page de confirmation
    //Sinon il est redirigé vers la page du formulaire de l'inscription à un événement en lui précisant l'erreur de paiement
    if (this.responseCode == "00" || this.responseCode == undefined) {
      this.router.navigate(['../confirmation'], {
        relativeTo: this.route,
        queryParams: {
          id: this.readableEventId
        }
      });
    }
    else {
      this.router.navigate([EventCheckoutRoutePaths.REGISTRATION], { queryParams: { id: this.readableEventId, error : "paymentError" } });
    }
  }

}
